var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow.companyImages
    ? _c(
        "div",
        {
          staticClass: "clearfix fs13 plr20 pt30 pb30 tc row-last",
          style:
            "background: url(" +
            _vm.userImageUrlForPc +
            "/top/bg_01.png) repeat left;",
          attrs: { "data-test": "images" },
        },
        [
          _c(
            "job-preview-right-column",
            _vm._g(
              {
                attrs: {
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "comment-class": "topic",
                  "comment-highlights": _vm.commentHighlights,
                  "text-count-class": "topic",
                  "text-counts": _vm.textCounts,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _vm._l([1, 2, 3], function (index) {
            return [
              _vm.companyInfo["companyImage" + index + "Caption"]
                ? _c("figure", { key: "image-" + index }, [
                    _vm.companyInfo["companyImage" + index].id
                      ? _c("img", {
                          staticClass: "company-img-sub",
                          attrs: {
                            id:
                              _vm.targetIdMap.companyInfo.images.image +
                              "-" +
                              index,
                            src: _vm.getPhotoUrl(
                              _vm.companyInfo["companyImage" + index]
                            ),
                            "data-test": "image-" + index,
                          },
                          on: {
                            load: function ($event) {
                              return _vm.$emit("onLoadImage")
                            },
                            error: function ($event) {
                              return _vm.$emit("onLoadImage")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("figcaption", {
                      staticClass: "tl fs12 mt15",
                      attrs: {
                        id:
                          _vm.targetIdMap.companyInfo.images.caption +
                          "-" +
                          index,
                        "data-test": "image-" + index + "-caption",
                      },
                      domProps: {
                        textContent: _vm._s(
                          _vm.companyInfo["companyImage" + index + "Caption"]
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }